import { theme } from '@branchjs/neo-components';
import { css } from 'emotion';

const icon = css`
  color: ${theme.colors.icon.default};
  display: inline-block;
  transform: scale(0.6);
`;

const wrapper = css`
  display: inline;
  position: relative;
`;

const relatedMetrics = css`
  margin-top: 10px;
`;

const styles = {
  icon,
  wrapper,
  relatedMetrics,
};

export default styles;
